module.exports = __webpack_public_path__ + "img/1.ad917cb7.jpg";